import { pushDeviceKitList, pushDevices } from "../../state/ducks";
import { dispatch } from "../../state/store";
import { fleetManagementUtil } from "../../utils";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_SHARED_CORE_URL;
const mercApiUrl = process.env.REACT_APP_MERCURY_API_URL;

const LIMIT = 3000;

const getRequestData = (endpoint, baseUrl = apiUrl) => {
  const url = `${baseUrl}/${endpoint}`;

  return url;
};

const fetchDevicesBatch = async (offset) => {
  const baseUrl = getRequestData("data/device");
  let url = `${baseUrl}?offset=${offset}&limit=${LIMIT}`;

  const result = await httpClient.get(url);

  return result;
};

const fetchDevices = async () => {
  let offset = 0;

  while (offset !== null) {
    const result = await fetchDevicesBatch(offset);

    const data = result?.data?.data;

    if (data && data?.length) {
      const formattedDevices = fleetManagementUtil.formatDevices(data);
      dispatch(pushDevices(formattedDevices));

      offset += data?.length;
    } else {
      offset = null;
    }
  }
};

const createDevice = async (device) => {
  const url = getRequestData("data/device");

  const result = await httpClient.post(url, {
    data: device
  });

  return result;
};

const createDeviceBatch = async (devicesFileText) => {
  const url = getRequestData("data/devices");

  const result = await httpClient.post(url, {
    data: devicesFileText,
    headers: {
      "content-type": "text/plain"
    }
  });

  return result;
};

const deleteDevice = async (dusn) => {
  const baseUrl = getRequestData("data/device");
  let url = `${baseUrl}?dusn=${dusn}`;

  const result = await httpClient.remove(url);

  return result;
};

const resetDevice = async (dusn) => {
  const url = getRequestData("device/hardReset", mercApiUrl);

  const result = await httpClient.post(url, {
    data: [dusn]
  });

  return result;
};

const fetchDeviceKitListBatch = async (offset) => {
  const baseUrl = getRequestData("device/kit");
  let url = `${baseUrl}?offset=${offset}&limit=${LIMIT}`;

  const result = await httpClient.get(url);

  return result;
};

const fetchDeviceKitList = async () => {
  let offset = 0;

  while (offset !== null) {
    const result = await fetchDeviceKitListBatch(offset);

    const data = result?.data?.data;

    if (data && data?.length) {
      const formattedDeviceKitList = fleetManagementUtil.formatDeviceKitList(result?.data?.data);
      dispatch(pushDeviceKitList(formattedDeviceKitList));

      offset += data?.length;
    } else {
      offset = null;
    }
  }
};

const createDeviceKit = async (deviceKitData) => {
  const url = getRequestData("device/kit");

  const result = await httpClient.post(url, {
    data: deviceKitData
  });

  return result;
};

const fleetManagementService = {
  fetchDevices,
  createDevice,
  createDeviceBatch,
  deleteDevice,
  resetDevice,
  fetchDeviceKitList,
  createDeviceKit
};

export default fleetManagementService;
